import { AddRiwayatPekerjaanPayload } from "../../../../models/RiwayatPekerjaan";
import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import { allRiwayatPekerjaanKey } from "../../queries/RiwayatPekerjaan/useFetchAllRiwayatPekerjaan";
import getQueryClient from "../../queryClient";
import ApiClient from "../../../apiClient";

export async function addRiwayatPekerjaan(data: AddRiwayatPekerjaanPayload) {
  const res = await ApiClient.post(`/AddPekerjaan`, data);
  return res.data;
}

export const useAddRiwayatPekerjaan = mutationWrapper(addRiwayatPekerjaan, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(allRiwayatPekerjaanKey);
  },
});
